export default {
  faturamento: (state) => state.ticketMedio && state.ticketMedio['VAL_FATURAMENTO'],
  inicioFidelidade: (state) => state.inicioFidelidade && state.inicioFidelidade['DAT_INICIO_FIDELIDADE'],
  mediaItensClientes: (state) => state.mediaItens && state.mediaItens['VAL_ITENS_NA_CESTA'],
  numeroCupons: (state) => state.ticketMedio && state.ticketMedio['NUM_CUPONS'],
  quantidadeClientesCadastrados: (state) => state.quantidadeClientesCadastrados,
  quantidadeClientesAtivos: (state) => state.quantidadeClientesAtivos,
  quantidadeClientesPerdidos: (state) => state.quantidadeClientesPerdidos,
  clientesNovos: (state) => state.clientesNovos,
  clientesAtivos: (state) => state.clientesAtivos,
  datasLimites: (state) => state.datasLimites,
  tamanhoSegmento: (state) => {
    if (state.evaluatedSegment) {
      return state.evaluatedSegment.clients_qty
    } else {
      return 0
    }
  },
  ticketMedioClientes: (state) => state.ticketMedio && state.ticketMedio['VAL_TICKET_MEDIO'],
}
